import { gql } from '@apollo/client';

export const SelectExternalSystemManual_FRAGMENT = gql`
  fragment SelectExternalSystemManual on SelectExternalSystemManualState {
    processorId
    __typename
  }
`;
